module.exports = __webpack_public_path__ + "static/img/logo_02.3b154eba.png";